/* eslint-disable react/prop-types */
import Paper from "@mui/material/Paper";
import Table from "@mui/material/Table";
import TableBody from "@mui/material/TableBody";
import TableContainer from "@mui/material/TableContainer";
import TableHead from "@mui/material/TableHead";
import * as React from "react";
import SoftButton from "components/SoftButton";
import TableHeadItems from "./TableHeadItems";
import FullTableHeader from "./FullTableHeader";
import FullTableBody from "./FullTableBody";
import MinimalTableBody from "./MinimalTableBody";
import MinimalTableHeader from "./MinimalTableHeader";


export default function GhollakMinBalanceTable({ data,calculateDetail, onClearFilterClick, isSubmitted, filterInfo, setSearchInfo, handleFilterChange, onFilterClick }) {
    return (
        <>
            <TableContainer component={Paper}>
                <Table>
                    <TableHead>
                        <TableHeadItems filterInfo={filterInfo} onClearFilterClick={onClearFilterClick} handleFilterChange={handleFilterChange} onFilterClick={onFilterClick} setFilterInfo={setSearchInfo} />
                        {calculateDetail?.annual_rate && <SoftButton size="small"
                            variant="gradient"
                            color="success">
                            نرخ سود: {calculateDetail?.annual_rate * 100} %
                            </SoftButton>}
                        {calculateDetail?.days_counted && <SoftButton size="small" style={{marginRight:10}}
                            variant="gradient"
                            color="info">
                            {calculateDetail?.days_counted} روز
                            </SoftButton>}
                        {isSubmitted && filterInfo?.to_for_date && filterInfo?.from_for_date && filterInfo?.investment_opportunity_id ? <MinimalTableHeader /> : <FullTableHeader />}
                    </TableHead>
                    <TableBody style={{ display: "block" }}>
                        {isSubmitted && filterInfo?.to_for_date && filterInfo?.from_for_date && filterInfo?.investment_opportunity_id ? <MinimalTableBody data={data} /> : <FullTableBody data={data} />}
                    </TableBody>
                </Table>
            </TableContainer>
        </>
    );
}
